import { useContextProvider } from "./../context/providers/ContextProvider";
import { useQuery } from "../_app/lib/query";
import { getCommunications, getDocumentPresignedUrl, getExportCsv } from "./api";
import { useFeedbackAlerts } from "../_app/hooks";
import { SortRequestParam } from "../_app/components/Table/helpers";
import { communicationFilters } from "./filterConfig";
import { Query } from "../filter/types";

export function useCommunications(page: number, limit: number, sort: SortRequestParam, queries: Query[] = [], options = {}) {
  const { setFeedbackAlertError } = useFeedbackAlerts();
  const { contextId: accountId } = useContextProvider();
  return useQuery({
    queryKey: ["communications", { accountId, page, limit, sort, queries }],
    queryFn: () => getCommunications(accountId, page, limit, sort, queries),
    ...options,

    onError: () => {
      setFeedbackAlertError("Could not fetch communications.");
    },
  });
}

export function useDocumentDownload(communicationId: string, options = {}) {
  const { contextId: accountId } = useContextProvider();
  return useQuery({
    queryKey: ["document-download", { accountId }],
    queryFn: () => getDocumentPresignedUrl(accountId, communicationId),
    ...options,
  });
}

export function useCommunicationFilters() {
  return { data: communicationFilters };
}

export function useExportAllCommunications(options: any = {}) {
  const { setFeedbackAlertError } = useFeedbackAlerts();
  const { contextId: accountId } = useContextProvider();
  return useQuery({
    queryKey: ["all-communications-export", { accountId }],
    queryFn: () => getExportCsv(accountId),
    enabled: false,
    gcTime: 0,

    onError: () => {
      setFeedbackAlertError("Cannot download communication export due to an error.");
    },

    ...options,
  });
}
